
import { PropType } from "vue";
import Team from '@/shared/teams/team';

export default {
  name: "EliminatedTeamItem",
  props: {
    team: {
      type: Object as PropType<Team>,
    }
  },
  setup(props: any) {
    let teamName = props.team.name + ' ';

    if (teamName.length > 23 && screen.width < process.env.VUE_APP_WIDTH_PHONE_PORTRAIT) {
      teamName = teamName.substring(0,20) + '...';
    }

    return { teamName };
  },
};
